var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-vertical',{scopedSlots:_vm._u([{key:"navbar",fn:function(ref){
var toggleVerticalMenuActive = ref.toggleVerticalMenuActive;
return [(_vm.isNotRequired)?_c('auto-logout'):_vm._e(),_c('navbar',{attrs:{"toggle-vertical-menu-active":toggleVerticalMenuActive}})]}}])},[[_c('div',{staticClass:"vertical-layout h-100"},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }